<div class="account-page">

  <aside class="account-nav">
    @if (isLoggedIn && user) {
      <div class="profile">
        <img [src]="avatar" class="profile-avatar" width="56" height="56" [alt]="user.pseudo" />
        <div class="profile-text">
          <strong class="profile-pseudo">{{user.pseudo}}</strong>
          @if (memberSince) {
            <small class="muted">{{ 'account.memberSince' | t: { date: memberSince } }}</small>
          }
        </div>
      </div>

      <a class="points-card" routerLink="/compte/club">
        <mat-icon class="points-icon">stars</mat-icon>
        <span class="points-text">
          <strong>{{ 'account.points' | t: { count: points?.available ?? 0 } }}</strong>
          @if (points) {
            <small [class]="'level-' + points.level">{{ 'club.level' | t: { level: ('club.levels.' + points.level | t) } }}</small>
          }
        </span>
        <mat-icon class="chevron">chevron_right</mat-icon>
      </a>

      <a class="post-cta" routerLink="/poster">
        <mat-icon>add_circle_outline</mat-icon>
        <span>{{ 'account.postCta' | t }}</span>
      </a>
    }

    <nav>
      @for (item of sections; track item.id) {
        <a class="nav-link" [routerLink]="['/compte', item.id]" [class.active]="item.id === section">
          <mat-icon>{{item.icon}}</mat-icon>
          <span class="nav-label">{{ item.labelKey | t }}</span>
          @if (item.isNew) {
            <span class="new-chip">{{ 'account.newBadge' | t }}</span>
          }
        </a>
      }
    </nav>

    <hr class="separator" />

    <a class="nav-link" routerLink="/settings/profil">
      <mat-icon>settings</mat-icon>
      <span class="nav-label">{{ 'header.settings' | t }}</span>
    </a>
    @if (isLoggedIn) {
      <button type="button" class="nav-link logout" (click)="logout()">
        <mat-icon>exit_to_app</mat-icon>
        <span class="nav-label">{{ 'header.logout' | t }}</span>
      </button>
    }
  </aside>

  <section class="account-content">
    @if (!isLoggedIn) {
      <div class="login-prompt">
        <mat-icon>lock_outline</mat-icon>
        <p>{{ 'account.loginPrompt' | t }}</p>
        <button type="button" class="btn-login" (click)="openLogin()">{{ 'header.loginOrSignup' | t }}</button>
      </div>
    } @else {
      @switch (section) {
        @case ('saved') { <app-saved-deals></app-saved-deals> }
        @case ('contributions') { <app-contributions></app-contributions> }
        @case ('club') { <app-points-club></app-points-club> }
        @case ('rewards') { <app-rewards-shop></app-rewards-shop> }
        @case ('stats') { <app-user-stats></app-user-stats> }
        @case ('badges') { <app-user-badges></app-user-badges> }
        @case ('expertise') { <app-user-expertise></app-user-expertise> }
      }
    }
  </section>
</div>
